export type Orient = "L" | "P" | "Pano"

export type FrameInput = {
  src: string
  alt: string
  orient: Orient
  rot: number
  delay: number
  dur: number
}
export type Frame = FrameInput & { href: string }

export type VideoInput = { src: string; title: string; tag: string }
export type VideoClip = VideoInput & { href: string }

export const RAW_FRAMES: ReadonlyArray<FrameInput> = [
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZrfucHPFxa0y34Ph6gVCbIRNklULfoXizYpeH",
    alt: "Production still, descent",
    orient: "L",
    rot: -3,
    delay: 0.4,
    dur: 6.8,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZVKUVRMGbBsNpgfRrHakELUZ61QjqlmXMSi9Y",
    alt: "Set photography, cast portrait",
    orient: "P",
    rot: 3.5,
    delay: 0.9,
    dur: 7.2,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZhkiOfnVelw1RnfpMGCxuWjmgAKYqdOXQbB4H",
    alt: "Pradeep & Jamie on set",
    orient: "L",
    rot: 1.2,
    delay: 1.6,
    dur: 6.5,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZL2lPTOqCzwXFcPYHUx2DeTuSdtyA3vI4q0hs",
    alt: "On location portrait",
    orient: "P",
    rot: -4,
    delay: 0.2,
    dur: 7,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZmsrGiOLDcnsNIHCbjWw0tk8QoXJ4EY1ZFMKy",
    alt: "Production still",
    orient: "L",
    rot: 2.4,
    delay: 1.4,
    dur: 7.6,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZkVzX1LDIx0gqenAzyTHG3jf95CFBbdK4vIsp",
    alt: "Production still",
    orient: "L",
    rot: -2.2,
    delay: 0.7,
    dur: 6.9,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZ4CSxgFECPcvdqme15R07KI2UbHglOfBroA9j",
    alt: "On location",
    orient: "L",
    rot: 4,
    delay: 1.9,
    dur: 7.4,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZlCrMv4jcJyuqaw8LfGSi1DW24zCo9BlepAdU",
    alt: "Crew portrait",
    orient: "P",
    rot: 3,
    delay: 0.5,
    dur: 6.6,
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZfuHI76DUOCByR91uNJYW7SZH30w4xmLdk6Vf",
    alt: "Production still",
    orient: "L",
    rot: 2,
    delay: 1.7,
    dur: 6.7,
  },
]

export const RAW_VIDEOS: ReadonlyArray<VideoInput> = [
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZ3Ls0dqPRIgrxQcFVMXlmhbv6Ltoai72sK5N8",
    title: "Ariel's Fight",
    tag: "REC·01",
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZwNbkqbaR41nNHWGrw8Z6E9ktoaBhqgjyxMsC",
    title: "Bhisma & Mutu",
    tag: "REC·02",
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZsYWPOd5TXir3kQM0bHzOp4cYtvyFjDnUmeBu",
    title: "Kalki Fight",
    tag: "REC·03",
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZiF1gegVdvV6aHBk1WmSs9T8IPn2xYy0ezhjf",
    title: "King Yama & Queen Mara",
    tag: "REC·04",
  },
  {
    src: "https://70fy8xbp6b.ufs.sh/f/BzM3qquY5hLZIgz2rZhfsSuqCYeyinG8kmcMDL4hRb9pxV0Q",
    title: "They Meet",
    tag: "REC·05",
  },
]

const withHref = <T extends { src: string }>(arr: ReadonlyArray<T>) =>
  arr.map((x) => ({ ...x, href: encodeURI(x.src) }))

export const FRAMES: ReadonlyArray<Frame> = withHref(RAW_FRAMES)
export const VIDEOS: ReadonlyArray<VideoClip> = withHref(RAW_VIDEOS)
export const FRAME_COUNT = FRAMES.length
export const VIDEO_COUNT = VIDEOS.length
